import React from 'react';
import MeetingLayoutSettings from '../MeetingLayoutSettings/MeetingLayoutSettings';
import Backdrop from '@material-ui/core/Backdrop';
import { makeStyles } from '@material-ui/core/styles';
import InteractionPages from '../InteractionPages/InteractionPages';
import Breakouts from '../Breakouts/Breakouts';
import './SettingsAside.css'


const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: 500,
        color: '#fff',
        marginTop: 56
    },
}));
export default function SettingsAside(props) {
    const [meetingLayoutExpanded, expand] = React.useState(false)
    const classes = useStyles();
    const toggleExpand = (value) => {
        expand(value)
    }
    if (props.eventId < 0) return null;
    return (
        <div>
            <Backdrop  className={classes.backdrop} onClick={() => props.toggleAside(false)} open={props.open}>
            </Backdrop>
            <div
            /*     fixed
                display="lg" */
                style={{ width: meetingLayoutExpanded && props.open ? "65vw" : undefined, zIndex: 550 }}
                className={props.open ? "moderator-settings-aside-show" : "moderator-settings-aside-hide"}
            >
     
                <InteractionPages {...props} />
                <Breakouts {...props}/>
                <MeetingLayoutSettings onExpand={toggleExpand} {...props} />
            </div>
        </div>

    );
}